import { Card } from "react-bootstrap";
import React, { useCallback, useRef, useState } from "react";
import CustomStore from "devextreme/data/custom_store";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem, } from "devextreme-react/cjs/data-grid";
import { useNavigate } from "react-router-dom";
import { getCartDetails } from "./services/cart.services";
import { formatDateToIST } from "helpers/dateFormat";
import ActionButton from "./components/ActionButton";

const CartDataList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const navigate = useNavigate()

    const dataSource = new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            try {
                const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                const response = await getCartDetails(parameterList);
                return response
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        }
    });

    const reloadDataSource = useCallback(() => {
        dataGridRef.current?.instance?.getDataSource()?.reload();
    }, []);


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Draft Transaction Details</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <DataGrid
                                dataSource={dataSource}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                ref={dataGridRef}
                                columnAutoWidth={true}
                                showBorders={true}

                                // for hide
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}

                                // for text-center 
                                onCellPrepared={(e) => {
                                    if (['data', 'header'].includes(e.rowType)) {
                                        e.cellElement.style.textAlign = 'center';
                                    }
                                }}

                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />

                                <Pager

                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <Summary>
                                    <TotalItem
                                    // column="Sr.No."
                                    // summaryType="count"
                                    // displayFormat="Total: {0}"
                                    />
                                </Summary>
                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />
                                <Column
                                    caption="Action"
                                    width="100px"
                                    allowFiltering={false}
                                    cssClass="text-center"
                                    cellRender={({ data }) => (
                                        <ActionButton selectedId={data.id} reloadDataSource={reloadDataSource} customerId={data.customerId} />
                                    )}
                                />
                                <Column
                                    dataField="productCount"
                                    caption="Products"
                                    dataType="string"
                                    width={"100px"}

                                />
                                <Column
                                    dataField="customerName"
                                    caption="Customer Name"
                                    dataType="string"
                                    width={"200px"}

                                />
                                <Column
                                    dataField="customerMobileNo"
                                    caption="Customer MobileNo."
                                    dataType="string"
                                    width={"200px"}
                                />
                                <Column
                                    dataField="addedBy"
                                    caption="Added By"
                                    dataType="string"
                                    width={"100px"}

                                />
                                <Column
                                    dataField="salesPersonName"
                                    caption="Sales Person"
                                    dataType="string"
                                    width={"200px"}
                                />
                                <Column
                                    dataField="addedOn"
                                    caption="Added On"
                                    dataType="string"
                                    calculateDisplayValue={(rowData) => formatDateToIST(rowData.addedOn)}
                                    width={"200px"}
                                    sortOrder="desc"
                                />
                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default CartDataList;